'use strict';


import analytics from '../analytics.js';
import util from '../util.js';
import page from '../page.js';


const checkGiftBalance = function() {
    $(document).on('submit', '#gccheckbalance', function(evt) {
        evt.preventDefault();
        var $form = $(this);
        $('#errorText').css('display', 'none');
        $('#balanceTxtSection').css('display', 'none');
        var widgetOpt;
        $.ajax({
            url: util.ajaxUrl(Urls.GCCheckBalance),
            data: $form.serialize(),
            method: 'POST',
            success: function(response) {
            	if (response.error) {
            		if(response.errorMsg === Resources.CSRF_TOKEN_MISMATCH){
            			page.redirect(Urls.csrffailed);
            		}
            	} else {
            		if (response.isGCValidationSuccess) {
                        $('#errorText').css('display', 'none');
                        $('#balanceText').html(Resources.CURRENCY_SYMBOL + response.GiftCardBalance);
                        $('#balanceTxtSection').css('display', 'block');
						analytics.pushGiftCardDataOnApproval();

                    } else {
                        $('#errorText')
                            .html(response.GCValidationMsg)
                            .css('display', 'block')
                            .focus();
                        $('#balanceTxtSection').css('display', 'none');
                    }
            	}         	            	
            },
        });
        if ($('#check_gc_bal') != null) {
            $('#check_gc_bal').css('height', 'auto');
        }
    });
};

const limitPinLength = function() {
	$('.giftcardpin').on('input', function() {
        var maxNum = $('.giftcardpin').attr('maxlength');
        if ($(this).val().length > maxNum) {
            $(this).val(
                $(this)
                    .val()
                    .substr(0, maxNum)
            );
        }
    });
};

export default {
    init: function () {
        checkGiftBalance();
        limitPinLength();
    }
}

